import { Skeleton } from '../../../../components';

const SkeletonLoader = ({ count = 15 }) => {
    return (
        <div>
            {Array.from({ length: count }, (_, i) => (
                <Skeleton type='contact' key={i} />
            ))}
        </div>
    );
};

export default SkeletonLoader;